import React from "react";
import Header from "../header/Header";
import HeroSection from "../herosection/HeroSection";
import Footer from "../footer/Footer";
import { config } from '../../config/env';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden overflow-y-clip">
      <div className="z-10 sticky top-0">
        <Header/>
      </div>
      <HeroSection 
          title={config.hero.title}
          description={config.hero.description}
          buttonLabel={config.hero.buttonLabel}
          buttonUrl={config.hero.buttonUrl} />
      <div className="flex-1 sm:mx-16 md:mx-20 lg:mx-32 xl:mx-auto xl:min-w-[1000px] xl:max-w-[1000px] 2xl:min-w-[1300px] 2xl:max-w-[1300px]">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
